import React, { Component } from 'react';

class WidgetTopSubCategories extends Component {

    constructor({ stores, fromDate, toDate, widget }) {
        super();
        this.state = {
            stores: stores,
            fromDate: fromDate, 
            toDate: toDate,
            widget: widget,
            subcategories: []
        }
    }

    async componentDidMount() {
        this.loadData(this.state.stores, this.state.fromDate, this.state.toDate, this.state.widget);
    }

    loadData(stores, fromDate, toDate, widget) {
        this.props.getSubCategoryWiseSales(this.props.user.user.RegistrationID, stores, fromDate, toDate, widget.WidgetOptionTopX, widget.WidgetOptionAmtOrQty)
            .then((result) => {
                this.setState({ subcategories: result.searchResult })
            });
    }

    componentWillReceiveProps({ stores, fromDate, toDate, widget }) {
        this.loadData(stores, fromDate, toDate, widget);
    }

    render() {
        return   <div className="dashboard-box " >
            <div className="dashboard-box-header">
                <div className="dashboard-box-title left">Sub Category</div>
                <div className="right">
                <button type="submit" className="btn pull-right btn-flat btn-default"
                    onClick={() => this.props.history.push({
                        pathname: "/home/reports/subcategorywise",
                        state: {
                            action: 'Sales Dashboard',
                            searchTransactionFromDate: this.state.searchTransactionFromDate,
                            searchTransactionToDate: this.state.searchTransactionToDate,
                            storeList: this.state.storeList
                        }
                    })}>View More</button>
                </div>
            </div>
            <div className="dashboard-box-body">
                <div className="table-responsive scroll2">
                    {this.state.subcategories.length > 0 && <table className="table table-striped no-margin">
                        <thead>
                            <tr>
                                <th>Sub Category</th>
                                <th style={{ textAlign: "right" }}>Qty</th>
                                <th style={{ textAlign: "right" }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.subcategories.map((subcategory,index) =>
                                <tr key={"subCat_" + index}>
                                    <td>{subcategory.name}</td>
                                    <td style={{ textAlign: "right" }}>{subcategory.total_qty}</td>
                                    <td style={{ textAlign: "right" }}>{subcategory.total_sales}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>}
                    {this.state.subcategories.length === 0 && "No records found"}
                </div>
            </div>
        </div>}
}

export default WidgetTopSubCategories